import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import SectionTitle from "../../components/Typography/SectionTitle";
import { APP_COLORS } from "../../utils/constants";

const expertiseArray = [
  {
    title: "Capital & Fundraising Strategies",
    description:
      "We develop comprehensive capital strategies, through innovative fundraising methodologies, ensuring businesses are investment ready and financially stable for the long term.",
  },
  {
    title: "SMEs Transformation & Scalability",
    description:
      "We enable small and medium-sized enterprises to navigate pivotal growth phases, preparing them to scale sustainably and effectively.",
  },
  {
    title: "Change Management & Corporate Governance",
    description:
      "We provide a roadmap for managing and implementing significant organizational shifts with minimal disruption, fostering a culture of resilience. We also establish robust governance frameworks and best practices that govern businesses for long-term health and make them investor-ready.",
  },
  {
    title: "Business Strategy & Execution",
    description:
      "We design and implement strategic blueprints, turning vision into actionable, measurable and sustainable outcomes.",
  },
  {
    title: "Brand Incubation & Development",
    description:
      "We craft compelling brands from the ground up, ensuring every detail reflects purpose and precision, from concept to market launch.",
  },
  {
    title: "Strategic Project Management",
    description:
      "We lead strategic initiatives from concept to completion, providing the expertise to ensure your projects meet objectives with clarity and control.",
  },
];
export default function ExpertiseSection({ id }) {
  return (
    <Box
      id={id}
      className="container-fluid section"
      sx={{
        backgroundColor: APP_COLORS.SECONDARY_BACKGROUND,
        px: { lg: "12rem" },
      }}
    >
      <Box
        className="container"
        sx={{ textAlign: "center", color: APP_COLORS.FONT }}
      >
        <SectionTitle title="Our Expertise" centered />

        <p
          style={{
            maxWidth: "930px",
            margin: "0 auto",
            fontSize: { xs: "1rem", lg: "18px" },
            lineHeight: 1.4,
            opacity: 0.9,
            marginTop: "3rem",
          }}
        >
          In a world driven by fast fixes, rubicon® is dedicated to the
          Craftsmanship of Business, delivering solutions that are intentional,
          intelligent, and built to endure.
          <br />
          We enable investments to grow with clarity, purpose, and resilience
          through our expertise in:
        </p>
      </Box>

      <Grid container spacing={2} sx={{ mt: 5, mx: { xs: 2, md: 10, lg: 0 } }}>
        {expertiseArray.map((expertise, index) => (
          <Grid
            size={{ xs: 12, md: 6, xl: 4 }}
            sx={{
              backgroundColor: APP_COLORS.SECONDARY,
              color: APP_COLORS.FONT,
              maxWidth: "30rem",
              pt: 10,
              px: { xs: 6, lg: 9 },
              pb: 10,
              mx: { xs: "auto", lg: 0 },
            }}
            key={index}
          >
            <Typography
              component="h3"
              variant="h3"
              sx={{
                fontSize: "1.7rem",
                fontWeight: 700,
                marginBottom: "5.5rem",
                height: { xs: "4rem", md: "5rem", lg: "4rem" },
                pb: { xs: index === expertiseArray.length - 1 ? 12 : 0, md: 0 },
              }}
            >
              {expertise.title}
            </Typography>
            <p
              style={{
                fontSize: "16px",
                lineHeight: 1.5,
                opacity: 0.9,
              }}
            >
              {expertise.description}
            </p>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
